import { Toggle } from "rsuite";

import NavBar from "./Navbar";
import AlertBanner from "./AlertBanner";
import { useConfig } from "../context/config-context";
import { useAlert } from "../context/alert-context";

export default function Gabarit({
  label,
  children,
  className,
  tutoMode,
  setTutoMode,
  leftComponent,
}) {
  const siteConfig = useConfig();
  const { alert, hideAlert } = useAlert();

  return (
    <div className="relative min-h-screen">
      <NavBar />
      {label ? (
        <div className="flex items-center justify-between gap-1 px-3 pt-3">
          <div className="flex items-center gap-1">
            <p className="text-2xl font-bold text-primary">{label}</p>
            {setTutoMode ? (
              <Toggle
                checked={tutoMode}
                onChange={(checked) => setTutoMode(checked)}
                checkedChildren="Mode démo"
                unCheckedChildren="Mode démo"
              />
            ) : null}
          </div>

          {leftComponent && <div className="self-end">{leftComponent}</div>}
        </div>
      ) : null}

      {/* Bandeau global d'alerte */}
      {alert && (
        <div className="px-3 pt-3">
          <AlertBanner
            type={alert.type}
            message={alert.message}
            onClose={hideAlert}
          />
        </div>
      )}

      <section className={`p-3 md:p-6 ${className}`}>{children}</section>

      {/* Logo preset — bas à gauche, fixe (desktop uniquement) */}
      <div className="hidden md:block fixed bottom-0 left-0 pointer-events-none -z-10">
        <img
          src={siteConfig.medias.logo_preset.path}
          alt={siteConfig.medias.logo_preset.alt}
          className="w-40 object-contain"
        />
      </div>
    </div>
  );
}
